import { useNavigate } from "react-router-dom";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

export const Title = ({ name, type }: { name?: string; type?: string }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "fixed",
        height: "70px",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        backgroundColor: "#fff",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <Paper elevation={0} sx={{ my: 2, position: "relative" }}>
        <IconButton
          color="primary"
          size="large"
          onClick={() => navigate(`/${type}`, { state: { noReload: true } })}
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            my: "auto",
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography
          variant="h6"
          width="100%"
          sx={{ px: "40px", wordBreak: "break-all" }}
        >
          {name && name.length > 12
            ? name.slice(0, 12) + "..."
            : name ?? "読込中..."}
        </Typography>
      </Paper>
    </Box>
  );
};
